import * as React from 'react'
import './App.css'
import { darkTheme, theme } from './theme.js'
import { Footer } from './components/Footer'

import { Box, CssBaseline } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'

import useMediaQuery from '@mui/material/useMediaQuery'
import { Header } from './components/Header'
import { MainTabs } from './components/MainTabs'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import Admin from './components/admin'
import { ReservationContextProvider } from './context/ReservationContext'

export default function App() {
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)')
  const [currentTheme, setCurrentTheme] = React.useState(prefersDarkMode ? darkTheme : theme)

  React.useEffect(() => {
    setCurrentTheme(prefersDarkMode ? darkTheme : theme)
  }, [prefersDarkMode])

  return (
    <div className='App'>
      <ThemeProvider theme={currentTheme}>
        <CssBaseline />

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh'
          }}
        >
          <Header currentTheme={currentTheme} setCurrentTheme={setCurrentTheme} />
          <Router>
            <Routes>
              <Route path='/' element={<MainTabs key='home' idx={'1'} step={0} />} />

              <Route path='/complete' element={<MainTabs key='complete' idx={'3'} step={5} />} />
              <Route path='/retry' element={<MainTabs key='retry' idx={'3'} step={4} />} />
              <Route path='/spectacles' element={<MainTabs key='shows' idx={'2'} step={0} />} />
              <Route
                path='/admin'
                element={
                  <ReservationContextProvider>
                    <Admin />{' '}
                  </ReservationContextProvider>
                }
              />
            </Routes>
          </Router>

          <Footer />
        </Box>
      </ThemeProvider>
    </div>
  )
}
